/**
 * Hook for fetching tenant sync preview
 */
import { TenantSyncConfig } from '../config';
import { queryKeys } from '@/hooks/constants';
import { useQueryWithLogging } from '@/hooks/useQueryWithLogging';
import Service from '@/lib/App';

interface UseSyncPreviewOptions {
  enabled?: boolean;
  [key: string]: unknown;
}

/**
 * Fetches the sync preview for a variable
 * Shows what will be synced to the tenant, including scenario and filtered targets
 */
export function useSyncPreview(
  variableName: string,
  config: TenantSyncConfig,
  options?: UseSyncPreviewOptions,
) {
  return useQueryWithLogging({
    queryKey: queryKeys.planner.tenantSyncPreview(config.name, variableName),
    queryFn: () =>
      Service.planner.getSyncPreview(variableName, config.tenantSeq),
    enabled: !!variableName && (options?.enabled ?? true),
    ...options,
  });
}
